import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import moment from "moment";

import { ReactComponent as InfoIcon } from "assets/images/icons/Info.svg";

interface ConversionRateProps {
  _class?: string;
  item: {
    target_currency: string;
    base_currency: string;
    new_rate?: number;
    rate: number;
    timestamp?: string;
  };
}

export default function ConversionRate({ item, _class }: ConversionRateProps) {
  return (
    <div className={`${_class}`}>
      <p className="text-secondary font-b3">
        <FormattedMessage id="quotation-form.conversionRate" defaultMessage="Conversion rate" /> 1 {item.target_currency} is{" "}
        {item.new_rate ?? item.rate} {item.base_currency}
      </p>
      <div className="d-flex align-items-center mt-xxs">
        <p className="text-secondary font-b3">
          {item.timestamp && ` (${moment.utc(item.timestamp).format("DD-MM-YYYY - HH:mm")} UTC)`}
        </p>
        {item.new_rate && item.rate && (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="original-conversion-rate">
                <p className="mt-md mb-md">
                  Original:{" "}
                  <span className="font-weight-bold">
                    1 {item.target_currency} is {item.rate} {item.base_currency}
                  </span>
                </p>
              </Tooltip>
            }
          >
            <InfoIcon className="text-secondary ml-sm" />
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
}

ConversionRate.defaultProps = {
  _class: "",
};
